interface BorderProps {
  children: React.ReactNode;
  additionalClasses?: string;
}

function Border({ additionalClasses, children }: BorderProps) {
  return (
    <div className={`flex flex-col gap-6 border p-2 ${additionalClasses}`}>
      {children}
    </div>
  );
}

export default Border;
